module.exports = __webpack_public_path__ + "img/banner-title-xl.54d3c4aa.png";